import { Injectable } from '@angular/core';

import { StringHash } from '@app/shared/utils/utils-types';
import { FormConfig } from '@app/shared/forms/dynamic-form/fields.service';

@Injectable()
export class RelatedFieldsService {
  private relatedFieldsHash: { [formId: number]: StringHash<string> } = {};

  constructor() {}

  public getRelatedFieldsFromFormConfig(form: FormConfig): StringHash<string> {
    if (!this.relatedFieldsHash[form.formId]) {
      let result = <StringHash<string>>{};
      const fields = form.formFields.filter(Boolean);

      form.formFields
        .filter(Boolean)
        .map((f) => f.fieldName)
        .forEach((fieldName) => {
          let relatedField = fields.find((f) => f?.relatedTo === fieldName);
          if (relatedField) {
            result[fieldName] = relatedField.fieldName;
            return;
          }

          relatedField = fields.find((f) => f.fieldName === fieldName && !!f.relatedTo && !!f.relatedTo?.length);

          if (relatedField) {
            result[fieldName] = relatedField.relatedTo;
          }
        });

      this.relatedFieldsHash[form.formId] = result;
    }

    return this.relatedFieldsHash[form.formId];
  }
}
